var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"page-container",attrs:{"id":"partners","fluid":""}},[_c('v-row',[_c('v-col',[_c('PartnerList')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }